import { DateTime } from 'luxon';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import type { MyJobItem } from '../../../../particles/api/core/api/callGetMyJobs';

export const JOB_TYPE_LABELS: Record<string, string> = {
  sync_contacts: 'Contact Sync',
  artifact_performance_report: 'Performance Report',
  artifact_cohort_report: 'Cohort Report',
  artifact_mortgage_report: 'Mortgage Report',
  artifact_negotiator_report: 'Negotiator Report',
  delete_company: 'Delete Company',
  signout_all_negotiator: 'Sign out all negotiator users'
};

export const STATUS_COLORS: Record<string, string> = {
  pending: '#ed6c02',
  running: '#1976d2',
  completed: '#2e7d32',
  failed: '#d32f2f',
  cancelled: '#9e9e9e'
};

export const STATUS_LABELS: Record<string, string> = {
  pending: 'Queued',
  running: 'In Progress',
  completed: 'Done',
  failed: 'Failed',
  cancelled: 'Cancelled'
};

interface GenerateRowsOptions {
  onMenuOpen: (job: MyJobItem, event: React.MouseEvent<HTMLElement>) => void;
}

const generateRows = (jobs: MyJobItem[], options: GenerateRowsOptions): TableRow[] =>
  jobs.map((job) => {
    const shareUrl = job.result?.shareUrl;
    const sendBlockers: string[] = job.result?.sendBlockers || [];

    const row: TableRow = {
      id: job.jobId,
      jobType: JOB_TYPE_LABELS[job.jobType] || job.jobType,
      status: {
        type: 'chip',
        data: [
          {
            text: STATUS_LABELS[job.status] || job.status,
            backgroundColor: STATUS_COLORS[job.status] || '#9e9e9e'
          }
        ]
      },
      createdAt: job.createdAt
        ? DateTime.fromISO(job.createdAt).toLocaleString(DateTime.DATETIME_MED)
        : '',
      completedAt: job.completedAt
        ? DateTime.fromISO(job.completedAt).toLocaleString(DateTime.DATETIME_MED)
        : '',
      result:
        job.status === 'completed' && shareUrl
          ? {
              type: 'action',
              data: [
                {
                  type: 'other',
                  icon: VisibilityIcon,
                  linkData: {
                    href: shareUrl,
                    onClick: () => window.open(shareUrl, '_blank')
                  }
                }
              ]
            }
          : '',
      error:
        job.status === 'failed' && job.errorMessage
          ? {
              type: 'text',
              data: { text: job.errorMessage, fontColor: '#d32f2f' }
            }
          : job.status === 'completed' && sendBlockers.length
            ? {
                type: 'text',
                data: { text: `Not ready to send: ${sendBlockers.join('; ')}`, fontColor: '#b26a00' }
              }
            : '',
      actions: {
        type: 'action',
        data: [
          {
            type: 'other',
            icon: MoreVertIcon,
            linkData: {
              onClick: (event: unknown) =>
                options.onMenuOpen(job, event as React.MouseEvent<HTMLElement>)
            }
          }
        ]
      }
    };

    return row;
  });

export default generateRows;
